import { render, staticRenderFns } from "./google_callback_page.vue?vue&type=template&id=22300680&scoped=true"
import script from "./google_callback_page.vue?vue&type=script&lang=js"
export * from "./google_callback_page.vue?vue&type=script&lang=js"
import style0 from "./google_callback_page.vue?vue&type=style&index=0&id=22300680&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "22300680",
  null
  
)

export default component.exports